
import React from 'react'
import SymptomCheckerWizard from '../components/SymptomsCheckerFlow/SymptomCheckerWizard'
import DigitalHealthFAB from '../components/Digitalhealth'
// import PreScreeningQuestions from '../components/SymptomChecker/PreScreeningQuestions'
// import MultiSymptomSelect from '../components/SymptomChecker/MultiSymptomSelect'

function symptoms() {
  return (
    <div>
      {/* <MultiSymptomSelect /> */}
      <DigitalHealthFAB/>
      <SymptomCheckerWizard />
    </div>
  )
}

export default symptoms
